(()=>{
const C={obs:'#0D0D0D',ash:'#1A1A1A',bone:'#E8E2D9',smoke:'#6E6A66',bruise:'#4A2559',merc:'#8B858F'};
const TIERS=[
 {s:1500, short:'%5',    name:'%5 indirim'},
 {s:4000, short:'%10',   name:'%10 indirim'},
 {s:7000, short:'çorap', name:'Siparişine çorap hediye'},
 {s:10500,short:'%15',   name:'%15 indirim'},
 {s:14000,short:'%20',   name:'%20 indirim'},
 {s:18000,short:'tişört',name:'Siparişine sürpriz tişört'},
];
const MAX=TIERS[TIERS.length-1].s;
const COIN=40; // jeton puanı: iyi oyuncu ~1.3 jeton/sn → ~150 puan/sn → son ödül ≈ 2 dk
/* ---------- tracking → Google Sheets (Apps Script web app) ---------- */
const CFG=window.LASTCALL||{};const RELAY_URL=CFG.relay||'';const SHOP_PATH=(CFG.shopPath&&!/^\/collections\/all\/?$/.test(CFG.shopPath))?CFG.shopPath:'/collections/urunler';
const rid=()=>Math.random().toString(36).slice(2,10)+Date.now().toString(36).slice(-4);
let PID='';try{PID=localStorage.getItem('bwbh_lc_pid')||'';if(!PID){PID=rid();localStorage.setItem('bwbh_lc_pid',PID);}}catch(e){PID=rid();}
const SID=rid();let runN=0;
function track(ev,data){if(!RELAY_URL)return;const body=JSON.stringify(Object.assign({ev,pid:PID,sid:SID,run:runN,ts:new Date().toISOString(),dev:/Mobi|Android|iPhone/i.test(navigator.userAgent)?'mobile':'desktop',ref:document.referrer||'',q:location.search||''},data||{}));
 try{if(navigator.sendBeacon&&navigator.sendBeacon(RELAY_URL,new Blob([body],{type:'text/plain'})))return;}catch(e){}
 try{fetch(RELAY_URL,{method:'POST',mode:'no-cors',keepalive:true,body});}catch(e){}}
track('view');
const $=id=>document.getElementById(id);
const cv=$('c'),ctx=cv.getContext('2d'),stage=$('stage'),ROOT=document.getElementById('lastcall');
let W=640,H=360,GROUND=300,DPR=1,scale=1,SPD=1;
const LOGO_SRC='data:image/png;base64,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';document.querySelectorAll('[data-lc-logo]').forEach(i=>i.src=LOGO_SRC);const LOGO=new Image();LOGO.src=LOGO_SRC;

TIERS.forEach(t=>{const d=document.createElement('div');d.className='lc-tick';d.style.left=(t.s/MAX*100)+'%';d.innerHTML='<i></i><em>'+t.short+'</em>';$('ladder').appendChild(d);t.el=d;});

/* ---------- pixel sprite (Hey Arnold GBA tarzı, Alp) ---------- */
const PAL={H:'#1f1612',h:'#3d2b22',S:'#efc6a8',s:'#d3a083',M:'#b86a5e',G:'#c9a24a',L:'#22302e',l:'#5d7470',T:'#141414',t:'#2a2a2a',J:'#34405f',j:'#252e48',K:'#E8E2D9',k:'#8B858F',P:'#4A2559',p:'#8B858F'};
const BODY=[
"........hH..hH........",
"......hHHHhHHHHh......",
".....HHHHhHHHHHHHh....",
"....HHHHHHHHhHHHHHH...",
"...HHHHhHHHHHHHHHHHH..",
"..HHHHHHHHHHhHHHHHHHH.",
"..hHHhHHHHHHHHHhHHHH..",
"..HHHHHHHHHhSHHSSSHH..",
"...HHHHHHHSShSSSSSSS..",
"...HHHHHSSHHHHSSHHHS..",
"...hHHHGGGGGGGGGGGGG..",
"....HHsSGLLLlLGSGLlG..",
"....HHsSGLLLLLGSGLLGS.",
"....hHsSSGGGGGSSSGGSS.",
".....HsSSSSSSSSSSSSS..",
".....ssSSSSSSSSMMMS...",
"......sSSSSSSSSSSs....",
"......ssSSSSSSSSs.....",
".........ssSSSS.......",
".........sSSSSs.......",
".......TTTsSSsTTT.....",
".....TTTTTTTTTTTTTT...",
"....TTTTTTTTTTTTTTTT..",
"....TTTTTTTTTTTTTTTT..",
"....TTTTTTTTTTTTTTTT..",
"....TTTTTTTttttttTT...",
".....TTTTTTTTTTTTTT...",
".....TTTTTTTTTTTTT....",
"......TTTTTTTTTTTT....",
"......TTTTTTTTTTT.....",
"......TTTTTTTTTTT.....",
"......JJJJJJJJJJJ.....",
];
const PX=2,COLS=22,ROWS=44;
const POSE={
 a:{fl:[[13,32],[17,36],[19,41]],bl:[[11,32],[9,37],[5,39]],fa:[[17,22],[14,26],[15,29]],ba:[[8,22],[11,26],[14,24]]},
 b:{fl:[[13,32],[14,37],[13,41]],bl:[[11,32],[13,35],[9,38]],fa:[[17,22],[17,27],[20,27]],ba:null},
 c:{fl:[[13,32],[11,37],[7,39]],bl:[[11,32],[15,36],[17,41]],fa:[[17,22],[20,25],[21,21]],ba:[[8,22],[6,26],[7,29]]},
 d:{fl:[[13,32],[17,35],[14,38]],bl:[[11,32],[12,37],[11,41]],fa:[[17,22],[17,27],[20,27]],ba:null},
 air:{fl:[[13,32],[17,35],[16,40]],bl:[[11,32],[9,37],[6,40]],fa:[[17,22],[20,25],[21,21]],ba:null},
 up:{fl:[[13,32],[17,35],[16,40]],bl:[[11,32],[9,37],[6,40]],fa:[[17,22],[19,18],[21,14]],ba:null},
};
function buildSprite(pose,jet){
 const g=BODY.map(r=>r.padEnd(COLS,'.').slice(0,COLS).split('')).concat(Array.from({length:ROWS-BODY.length},()=>Array(COLS).fill('.')));
 const plot=(x,y,c,behind)=>{x=Math.round(x);y=Math.round(y);if(y<0||y>=ROWS||x<0||x>=COLS)return;if(behind&&g[y][x]!=='.')return;g[y][x]=c;};
 const seg=(a,b,c,th,behind)=>{const n=Math.max(Math.abs(b[0]-a[0]),Math.abs(b[1]-a[1]))*2+1;for(let i=0;i<=n;i++){const x=a[0]+(b[0]-a[0])*i/n,y=a[1]+(b[1]-a[1])*i/n;for(let dx=0;dx<th;dx++)for(let dy=0;dy<th;dy++)plot(x+dx-(th>>1),y+dy-(th>>1),c,behind);}};
 const lerp=(a,b,k)=>[a[0]+(b[0]-a[0])*k,a[1]+(b[1]-a[1])*k];
 const arm=(A,skin,behind)=>{if(!A)return;const [sh,el,ha]=A;const cut=lerp(sh,el,.38);seg(sh,cut,'T',3,behind);seg(cut,el,skin,3,behind);seg(el,ha,skin,2,behind);plot(ha[0],ha[1],skin,behind);plot(ha[0]+1,ha[1],skin,behind);};
 const leg=(L,c)=>{seg(L[0],L[1],c,3);seg(L[1],L[2],c,3);const f=L[2];for(let dx=-1;dx<=3;dx++){plot(f[0]+dx,f[1]+1,'K');plot(f[0]+dx,f[1]+2,'k');}plot(f[0]-1,f[1],'K');plot(f[0],f[1],'K');};
 const P0=POSE[pose];
 if(jet){for(let y=21;y<28;y++)for(let x=2;x<5;x++)plot(x,y,'P',true);plot(3,28,'p',true);plot(2,28,'p',true);}
 arm(P0.ba,'s',true);
 leg(P0.bl,'j');leg(P0.fl,'J');
 arm(P0.fa,'S',false);
 const c=document.createElement('canvas');c.width=(COLS+2)*PX;c.height=(ROWS+2)*PX;const x=c.getContext('2d');
 x.fillStyle='rgba(232,226,217,.85)';
 for(let r=-1;r<=ROWS;r++)for(let q=-1;q<=COLS;q++){if(g[r]&&g[r][q]&&g[r][q]!=='.')continue;
   if([[0,1],[1,0],[0,-1],[-1,0]].some(([a,b])=>g[r+a]&&g[r+a][q+b]&&g[r+a][q+b]!=='.'))x.fillRect((q+1)*PX,(r+1)*PX,PX,PX);}
 for(let r=0;r<ROWS;r++)for(let q=0;q<COLS;q++){const ch=g[r][q];if(ch==='.')continue;x.fillStyle=PAL[ch];x.fillRect((q+1)*PX,(r+1)*PX,PX,PX);}
 
 return c;
}
let SPR={};
function buildAll(){SPR={a:buildSprite('a'),b:buildSprite('b'),c:buildSprite('c'),d:buildSprite('d'),air:buildSprite('air'),ja:buildSprite('air',1),jup:buildSprite('up',1)};}
buildAll();

function resize(){
  const w=stage.parentElement.clientWidth;if(!w)return;
  const full=ROOT.classList.contains('is-full');
  const topOff=full?0:Math.min(160,Math.max(0,ROOT.getBoundingClientRect().top+window.scrollY));
  const avail=Math.max(220,window.innerHeight-topOff-(full?150:170));
  let dispH;
  if(w<700){W=420;dispH=Math.min(avail,w*1.35);H=Math.round(dispH*W/w);}
  else{W=Math.round(Math.min(960,Math.max(520,w/Math.min(avail,w*0.62)*360)));H=360;dispH=w*H/W;}
  GROUND=H-60;
  SPD=Math.min(1,Math.max(.66,W/720));
  stage.style.height=dispH+'px';
  DPR=Math.min(3,window.devicePixelRatio||1);
  scale=w/W;
  cv.width=Math.round(w*DPR);cv.height=Math.round(dispH*DPR);
  ctx.setTransform(scale*DPR,0,0,scale*DPR,0,0);
  ctx.imageSmoothingEnabled=false;
  if(!running)draw();
  fitRoot();
}

let best=0;try{best=+localStorage.getItem('bwbh_lastcall_best')||0}catch(e){}
$('best').textContent=best.toLocaleString('tr-TR');

let actx=null,muted=false;
function beep(f,d=.08,type='square',v=.05){if(muted)return;try{actx=actx||new (window.AudioContext||window.webkitAudioContext)();const o=actx.createOscillator(),g=actx.createGain();o.type=type;o.frequency.value=f;g.gain.value=v;g.gain.exponentialRampToValueAtTime(.0001,actx.currentTime+d);o.connect(g).connect(actx.destination);o.start();o.stop(actx.currentTime+d)}catch(e){}}
$('mute').onclick=e=>{muted=!muted;e.currentTarget.textContent=muted?'×':'♪';e.currentTarget.setAttribute('aria-label',muted?'Sesi aç':'Sesi kapat')};

const rnd=(a,b)=>a+Math.random()*(b-a);
function makeLayer(minH,maxH,minW,maxW,galata){const arr=[];let x=0;while(x<2400){const w=rnd(minW,maxW);arr.push({x,w,h:rnd(minH,maxH),win:Math.random(),g:galata&&Math.random()<.12});x+=w+rnd(2,18);}return {arr,len:x};}
const far=makeLayer(60,150,40,90,true),mid=makeLayer(40,110,50,120,false);
const lamps=[0,320,640,960];

let running=false,over=false,paused=false,t=0,score=0,speed=300,bgx=0,holding=false,tierIdx=-1,loopShown=false,coins=0;
const P={x:80,y:0,vy:0,w:44,h:88,ground:true,jumps:0,jet:0,phase:0};
let obs=[],items=[],parts=[],pops=[],toNext=600,toHeart=20;

function reset(){t=0;score=0;speed=300*SPD;obs=[];items=[];parts=[];pops=[];toNext=700;toHeart=rnd(16,24);tierIdx=-1;loopShown=false;coins=0;
 P.y=GROUND-P.h;P.vy=0;P.ground=true;P.jumps=0;P.jet=0;holding=false;
 TIERS.forEach(t=>t.el.classList.remove('lc-on'));$('fill').classList.remove('lc-max');hud();}

function spawn(){
 const tt=t;
 let kinds=['cone','block'];
 if(tt>12)kinds.push('box','low');
 if(tt>30)kinds.push('high','high');
 if(tt>55)kinds.push('combo');
 if(tt>85)kinds.push('stack','combo');
 const k=kinds[Math.floor(Math.random()*kinds.length)];
 const x=W+40;
 const add=o=>obs.push(Object.assign({x,rot:0,bob:0},o));
 if(k==='cone')add({k,w:28,h:40,y:GROUND-40});
 else if(k==='block')add({k,w:36,h:36,y:GROUND-36});
 else if(k==='box')add({k,w:48,h:54,y:GROUND-54});
 else if(k==='stack')add({k:'box2',w:48,h:92,y:GROUND-92});
 else if(k==='low')add({k:'bubble',txt:'görüldü ✓✓',w:96,h:32,y:GROUND-68});
 else if(k==='high')add({k:'bubble',txt:'u up?',w:70,h:32,y:GROUND-196,bob:Math.random()*6});
 else if(k==='combo'){add({k:'cone',w:28,h:40,y:GROUND-40});obs.push({k:'bubble',txt:'u up?',w:70,h:32,y:GROUND-200,x:x+speed*0.62,bob:0,rot:0});}
 if(Math.random()<.45){const n=4,base=Math.random()<.5?GROUND-46:GROUND-130;const off=speed*rnd(.38,.55);for(let i=0;i<n;i++)items.push({k:'coin',x:x+off+i*36,y:base-Math.sin(i/(n-1)*Math.PI)*36,w:22,h:22});}
 const minGap=.80-.14*Math.min(1,tt/130);
 toNext=speed*rnd(minGap,minGap+.8)+(k==='combo'?speed*.6:0)+(k==='stack'?80:0);
}

function press(){
 if(!running)return; holding=true;
 if(P.jet>0)return;
 if(P.ground){P.vy=-760;P.ground=false;P.jumps=1;beep(520,.07);}
 else if(P.jumps<2){P.vy=-680;P.jumps=2;beep(700,.07);puff(P.x+30,P.y+P.h,6);}
}
function release(){holding=false;if(running&&P.jet<=0&&P.vy<-320)P.vy=-320;}
function puff(x,y,n,col){for(let i=0;i<n;i++)parts.push({x,y,vx:rnd(-80,40),vy:rnd(-60,20),l:rnd(.25,.5),c:col||C.smoke,r:rnd(1.5,3)});}

const toastEl=$('toast');let toastT;
function toast(m){toastEl.textContent=m;toastEl.classList.add('lc-show');clearTimeout(toastT);toastT=setTimeout(()=>toastEl.classList.remove('lc-show'),2200);}
function hit(a,b){return a.x<b.x+b.w&&a.x+a.w>b.x&&a.y<b.y+b.h&&a.y+a.h>b.y;}

function update(dt){
 t+=dt;
 speed=(300+430*Math.min(1,t/130))*SPD;
 score+=100*dt;
 bgx+=speed*dt;
 if(P.jet>0){P.jet-=dt;
   if(holding){P.vy-=3400*dt;if(P.vy<-480)P.vy=-480;puff(P.x+6,P.y+62,1,Math.random()<.5?'#6b3a80':C.bone);}
   P.vy+=1700*dt;
   if(P.jet<=0)toast('Jetpack bitti.');
 } else P.vy+=2200*dt;
 P.y+=P.vy*dt;
 if(P.y<10){P.y=10;P.vy=Math.max(P.vy,0);}
 if(P.y>=GROUND-P.h){if(!P.ground&&P.vy>300)puff(P.x+30,GROUND,4);P.y=GROUND-P.h;P.vy=0;P.ground=true;P.jumps=0;} else P.ground=false;
 P.phase+=dt*speed/30;
 toNext-=speed*dt; if(toNext<=0)spawn();

 const pb={x:P.x+12,y:P.y+8,w:24,h:P.h-12};
 for(const o of obs){o.x-=speed*dt;if(o.k==='block')o.rot+=dt*speed/18;if(o.k==='bubble')o.bob+=dt*3;
   const hb=o.k==='bubble'?{x:o.x+5,y:o.y+4+Math.sin(o.bob)*3,w:o.w-10,h:o.h-8}:{x:o.x+5,y:o.y+5,w:o.w-10,h:o.h-5};
   if(hit(pb,hb)){die();return;}}
 obs=obs.filter(o=>o.x>-140);
 for(const it of items){it.x-=speed*dt;
   if(!it.got&&hit(pb,it)){it.got=true;
     if(it.k==='coin'){score+=COIN;coins++;beep(1180,.06,'triangle',.06);puff(it.x+11,it.y+11,5,C.bone);pops.push({x:it.x,y:it.y,txt:'+'+COIN,l:.8});}
     else{P.jet=6;beep(300,.25,'sawtooth',.05);toast('Jetpack! Basılı tut, uç.');puff(it.x+14,it.y+13,12,'#6b3a80');pops.push({x:it.x,y:it.y,txt:'JETPACK',l:1});}}}
 items=items.filter(i=>i.x>-40&&!i.got);
 for(const p of parts){p.x+=(p.vx-speed*.6)*dt;p.y+=p.vy*dt;p.l-=dt;}
 parts=parts.filter(p=>p.l>0);
 for(const p of pops){p.y-=50*dt;p.x-=speed*.3*dt;p.l-=dt;}
 pops=pops.filter(p=>p.l>0);
 while(tierIdx<TIERS.length-1&&score>=TIERS[tierIdx+1].s){tierIdx++;TIERS[tierIdx].el.classList.add('lc-on');beep(880,.12,'triangle',.07);setTimeout(()=>beep(1320,.14,'triangle',.06),110);
   toast(tierIdx===TIERS.length-1?'Sürpriz tişört kilidi açıldı.':TIERS[tierIdx].name+' açıldı. Devam.');}
 if(score>=MAX&&!loopShown){loopShown=true;$('fill').classList.add('lc-max');setTimeout(()=>toast('Bar doldu. Artık rekor için koşuyorsun.'),2300);}
 hud();
}
const fmtT=s=>{s=Math.floor(s);return Math.floor(s/60)+':'+String(s%60).padStart(2,'0')};
function hud(){
 $('score').textContent=Math.floor(score).toLocaleString('tr-TR');
 $('time').textContent=fmtT(t);
 $('fill').style.width=Math.min(100,score/MAX*100)+'%';
}

/* ---------- drawing ---------- */
const R=Math.round;
function rr(c,x,y,w,h,r){c.beginPath();c.moveTo(x+r,y);c.arcTo(x+w,y,x+w,y+h,r);c.arcTo(x+w,y+h,x,y+h,r);c.arcTo(x,y+h,x,y,r);c.arcTo(x,y,x+w,y,r);c.closePath();}
function drawBg(){
 const g=ctx.createLinearGradient(0,0,0,GROUND);g.addColorStop(0,'#0a090c');g.addColorStop(.6,'#140f19');g.addColorStop(1,'#2b1736');
 ctx.fillStyle=g;ctx.fillRect(0,0,W,GROUND);
 ctx.fillStyle='rgba(232,226,217,.9)';ctx.beginPath();ctx.arc(W*.78,62,18,0,7);ctx.fill();
 ctx.fillStyle='#0d0b10';ctx.beginPath();ctx.arc(W*.78+7,57,16,0,7);ctx.fill();
 ctx.fillStyle='rgba(232,226,217,.35)';for(let i=0;i<26;i++){const x=(i*97.3-bgx*.02)%W;ctx.fillRect(R((x+W)%W),(i*53)%140+8,1,1);}
 layer(far,.12,'#17131b','rgba(232,226,217,.10)',GROUND-6);
 layer(mid,.32,'#100d12','rgba(232,226,217,.16)',GROUND);
 for(const lx0 of lamps){const lx=R(((lx0-bgx*.7)%1280+1280)%1280-60);
   const gr=ctx.createRadialGradient(lx+14,GROUND-118,2,lx+14,GROUND-118,70);gr.addColorStop(0,'rgba(232,226,217,.2)');gr.addColorStop(1,'rgba(232,226,217,0)');
   ctx.fillStyle=gr;ctx.fillRect(lx-60,GROUND-190,150,150);
   ctx.fillStyle='#1d1a1f';ctx.fillRect(lx,GROUND-120,4,120);ctx.fillRect(lx,GROUND-122,18,4);
   ctx.fillStyle=C.bone;ctx.fillRect(lx+12,GROUND-119,6,3);}
 ctx.fillStyle=C.ash;ctx.fillRect(0,GROUND,W,H-GROUND);
 ctx.fillStyle='#2a2729';ctx.fillRect(0,GROUND,W,3);
 ctx.fillStyle='rgba(110,106,102,.5)';const off=bgx%80;for(let x=-off;x<W;x+=80)ctx.fillRect(R(x),GROUND+28,40,3);
}
function layer(L,par,col,win,base){
 const off=(bgx*par)%L.len;
 const HS=GROUND/300;for(let rep=0;rep<2;rep++)for(const b0 of L.arr){const b={...b0,h:b0.h*HS};const x=R(b.x-off+rep*L.len);if(x>W||x+b.w<0)continue;
  ctx.fillStyle=col;
  if(b.g){const cx=R(x+b.w/2);ctx.fillRect(cx-11,base-b.h-40,22,b.h+40);ctx.beginPath();ctx.moveTo(cx-14,base-b.h-40);ctx.lineTo(cx,base-b.h-78);ctx.lineTo(cx+14,base-b.h-40);ctx.fill();
    ctx.fillStyle=win;ctx.fillRect(cx-8,base-b.h-34,16,2);continue;}
  ctx.fillRect(x,base-b.h,b.w,b.h);
  ctx.fillStyle=win;for(let wy=base-b.h+8;wy<base-10;wy+=12)for(let wx=x+6;wx<x+b.w-6;wx+=10){if(((wx*7+wy*3+b.win*100)|0)%5===0)ctx.fillRect(wx,wy,3,4);}
 }
}
function teeText(c,x,y,k){c.save();c.fillStyle=C.bone;c.font='italic 700 '+(8.5*k)+'px "Bodoni Moda","Didot",Georgia,serif';c.textAlign='center';c.textBaseline='alphabetic';c.fillText('bwbh',x+24*k,y+57*k);c.restore();}
function playerSprite(){
 if(P.jet>0)return holding?SPR.jup:SPR.ja;
 if(!P.ground)return SPR.air;
 const f=((Math.floor(P.phase)%4)+4)%4;return [SPR.a,SPR.b,SPR.c,SPR.d][f];
}
function drawPlayer(){
 const s=playerSprite();const bob=(P.ground&&Math.floor(P.phase)%2)?-1:0;
 const x=R(P.x-PX),y=R(P.y-PX+bob);
 if(P.jet>0&&holding){ctx.fillStyle='rgba(232,226,217,.9)';ctx.beginPath();ctx.moveTo(x+5,y+60);ctx.lineTo(x+8,y+72+Math.random()*10);ctx.lineTo(x+11,y+60);ctx.fill();}
 ctx.drawImage(s,x,y);
 teeText(ctx,x,y,1);
 if(P.jet>0){ctx.strokeStyle=C.bone;ctx.lineWidth=3;ctx.beginPath();ctx.arc(x+24,y-8,7,-Math.PI/2,-Math.PI/2+Math.PI*2*(P.jet/6));ctx.stroke();}
}
function drawBlocked(c,cx,cy,r,rot){
 c.save();c.translate(cx,cy);c.rotate(rot||0);
 c.fillStyle='rgba(232,226,217,.12)';c.beginPath();c.arc(0,0,r+5,0,7);c.fill();
 c.fillStyle='#0d0d0d';c.beginPath();c.arc(0,0,r,0,7);c.fill();
 c.strokeStyle=C.bone;c.lineWidth=r*.26;c.beginPath();c.arc(0,0,r-r*.13,0,7);c.stroke();
 c.beginPath();c.moveTo(-r*.6,-r*.6);c.lineTo(r*.6,r*.6);c.stroke();c.restore();
}
function drawCone(c,x,y){c.fillStyle=C.bone;c.beginPath();c.moveTo(x+14,y);c.lineTo(x+26,y+36);c.lineTo(x+2,y+36);c.closePath();c.fill();
 c.fillStyle=C.smoke;c.fillRect(x+8,y+14,12,5);c.fillRect(x+5,y+25,18,5);c.fillStyle='#3a3634';c.fillRect(x,y+36,28,4);}
function drawBubble(c,x,y,w,h,txt){c.fillStyle=txt==='u up?'?'#5b2e6e':'#3a3638';rr(c,x,y,w,h,15);c.fill();
 c.strokeStyle='rgba(232,226,217,.55)';c.lineWidth=1.5;c.stroke();
 c.fillStyle=txt==='u up?'?'#5b2e6e':'#3a3638';c.beginPath();c.moveTo(x+9,y+h-4);c.lineTo(x-3,y+h+5);c.lineTo(x+18,y+h-2);c.fill();
 c.fillStyle=C.bone;c.font='600 15px Jost,sans-serif';c.textAlign='center';c.textBaseline='middle';c.fillText(txt,x+w/2,y+h/2+1);c.textAlign='left';c.textBaseline='alphabetic';}
function drawCoin(c,cx,cy,r){c.fillStyle='rgba(232,226,217,.18)';c.beginPath();c.arc(cx,cy,r+4,0,7);c.fill();
 c.fillStyle=C.bone;c.beginPath();c.arc(cx,cy,r,0,7);c.fill();c.strokeStyle=C.merc;c.lineWidth=2;c.beginPath();c.arc(cx,cy,r-3,0,7);c.stroke();
 c.fillStyle=C.obs;c.font='italic 700 '+Math.round(r*1.3)+'px "Bodoni Moda",Georgia,serif';c.textAlign='center';c.textBaseline='middle';c.fillText('b',cx,cy+1);c.textAlign='left';c.textBaseline='alphabetic';}
function drawHeart(c,cx,cy,s){c.save();c.translate(cx,cy);c.scale(s,s);
 const gl=c.createRadialGradient(0,0,2,0,0,26);gl.addColorStop(0,'rgba(122,74,143,.65)');gl.addColorStop(1,'rgba(74,37,89,0)');c.fillStyle=gl;c.fillRect(-26,-26,52,52);
 c.fillStyle='#7a4290';c.beginPath();c.moveTo(0,11);c.bezierCurveTo(-17,-2,-9,-15,0,-5);c.bezierCurveTo(9,-15,17,-2,0,11);c.fill();
 c.strokeStyle=C.bone;c.lineWidth=1.4;c.beginPath();c.moveTo(0,-5);c.lineTo(-2,0);c.lineTo(2,3);c.lineTo(0,9);c.stroke();c.restore();}
function drawObs(o){
 const x=R(o.x);
 if(o.k==='cone')drawCone(ctx,x,o.y);
 else if(o.k==='block')drawBlocked(ctx,x+18,o.y+18,17,-o.rot/18);
 else if(o.k==='box'||o.k==='box2'){const n=o.k==='box2'?2:1,bh=o.h/n;for(let i=0;i<n;i++){const y=o.y+i*bh;ctx.fillStyle='#3a312a';ctx.fillRect(x,y,o.w,bh-2);ctx.fillStyle='#4a3f36';ctx.fillRect(x,y,o.w,6);
   ctx.strokeStyle='rgba(232,226,217,.5)';ctx.lineWidth=1;ctx.strokeRect(x+.5,y+.5,o.w-1,bh-3);
   ctx.fillStyle=C.bone;ctx.fillRect(x+o.w/2-3,y,6,bh-2);ctx.font='italic 600 10px "Bodoni Moda",Georgia,serif';ctx.fillText('bwbh',x+5,y+bh-9);}}
 else if(o.k==='bubble')drawBubble(ctx,x,R(o.y+Math.sin(o.bob)*3),o.w,o.h,o.txt);
}
function drawItem(it){const x=R(it.x);
 if(it.k==='coin')drawCoin(ctx,x+11,R(it.y+11+Math.sin(t*5+it.x*.05)*2),11);
 else drawHeart(ctx,x+14,it.y+13,1+Math.sin(t*8)*.08);
}
function draw(){
 drawBg();
 for(const it of items)drawItem(it);
 for(const o of obs)drawObs(o);
 for(const p of parts){ctx.globalAlpha=Math.max(0,p.l*2);ctx.fillStyle=p.c;ctx.fillRect(R(p.x),R(p.y),3,3);}
 ctx.globalAlpha=1;
 drawPlayer();
 ctx.font='700 15px Jost,sans-serif';ctx.fillStyle=C.bone;
 for(const p of pops){ctx.globalAlpha=Math.min(1,p.l*2);ctx.fillText(p.txt,R(p.x),R(p.y));}
 ctx.globalAlpha=1;
}

/* ---------- rule icons ---------- */
function icons(){
 const ic=(id,fn)=>{const c=$(id).getContext('2d');c.clearRect(0,0,80,80);c.imageSmoothingEnabled=false;fn(c);};
 ic('ic-jump',c=>{c.drawImage(SPR.b,19,0,42,80);});
 ic('ic-block',c=>drawBlocked(c,40,40,26,0));
 ic('ic-up',c=>{c.scale(1.05,1.05);drawBubble(c,6,22,64,30,'u up?');});
 ic('ic-coin',c=>drawCoin(c,40,40,22));
}

/* ---------- share card (1080x1920 story) ---------- */
function storyCard(sc,tier){
 const c=document.createElement('canvas');c.width=1080;c.height=1920;const x=c.getContext('2d');
 const g=x.createLinearGradient(0,0,0,1920);g.addColorStop(0,'#0b0a0d');g.addColorStop(.55,'#160f1b');g.addColorStop(1,'#2e1839');x.fillStyle=g;x.fillRect(0,0,1080,1920);
 x.fillStyle='rgba(232,226,217,.4)';for(let i=0;i<70;i++)x.fillRect((i*157.3)%1080,(i*97)%900,3,3);
 // skyline
 x.fillStyle='#120e15';let bx=0;let s=7;while(bx<1080){const w=60+((s=s*16807%2147483647)%90),h=120+(s%260);x.fillRect(bx,1620-h,w,h);bx+=w+8;}
 x.fillRect(820,1300,60,320);x.beginPath();x.moveTo(812,1300);x.lineTo(850,1200);x.lineTo(888,1300);x.fill();
 x.fillStyle='#1A1A1A';x.fillRect(0,1620,1080,300);x.fillStyle='#2a2729';x.fillRect(0,1620,1080,6);
 // logo + title
 if(LOGO.complete){const lw=300,lh=LOGO.height*lw/LOGO.width;x.drawImage(LOGO,(1080-lw)/2,130,lw,lh);}
 x.fillStyle=C.bone;x.textAlign='center';
 x.font='italic 500 120px "Bodoni Moda",Georgia,serif';x.fillText('Last Call',540,400);
 x.font='500 30px Jost,sans-serif';x.fillStyle=C.merc;x.letterSpacing='10px';x.fillText('AFTERHOURS RUN',540,460);x.letterSpacing='0px';
 // score
 x.fillStyle=C.merc;x.font='500 30px Jost,sans-serif';x.fillText('SKOR',540,590);
 x.fillStyle=C.bone;x.font='500 220px "Bodoni Moda",Georgia,serif';x.fillText(sc.toLocaleString('tr-TR'),540,790);
 x.font='400 40px Jost,sans-serif';x.fillStyle='#cfc8be';x.fillText(fmtT(t)+' koştu  ·  '+coins+' jeton',540,870);
 // ladder
 const L=150,Rr=930,yy=960;x.fillStyle='#2a2729';x.fillRect(L,yy-4,Rr-L,8);
 const p=Math.min(1,sc/MAX);x.fillStyle='#6b3a80';x.fillRect(L,yy-4,(Rr-L)*p,8);
 TIERS.forEach((tt,i)=>{const px=L+(Rr-L)*tt.s/MAX;const on=sc>=tt.s;x.fillStyle=on?C.bone:'#0d0d0d';x.beginPath();x.arc(px,yy,15,0,7);x.fill();x.strokeStyle=on?C.bone:C.smoke;x.lineWidth=3;x.stroke();
  x.fillStyle=on?C.bone:C.smoke;x.font='500 28px Jost,sans-serif';x.fillText(tt.short,px,yy+60);});
 x.fillStyle=C.bone;x.font='italic 500 56px "Bodoni Moda",Georgia,serif';
 x.fillText(tier?(tierIdx===TIERS.length-1?'Kulübe girdi.':tier.name+' kaptı.'):'Kapıda kaldı.',540,1100);
 // character
 x.imageSmoothingEnabled=false;const sp=SPR.c;const k=5.2;const sx=540-sp.width*k/2,sy=1620-sp.height*k+3*k;x.drawImage(sp,sx,sy,sp.width*k,sp.height*k);teeText(x,sx,sy,k);
 // footer
 x.fillStyle=C.bone;x.font='600 46px Jost,sans-serif';x.fillText('Beni geçebilir misin?',540,1740);
 x.fillStyle=C.bone;x.font='500 38px Jost,sans-serif';x.fillText('@boyswithbrokenhearts',540,1806);x.fillStyle=C.merc;x.font='400 30px Jost,sans-serif';x.fillText('boyswithbrokenhearts.com/pages/last-call',540,1858);
 return c;
}
let storyBlob=null;
function makeStory(sc,tier){
 const c=storyCard(sc,tier);const url=c.toDataURL('image/png');$('storyImg').src=url;$('saveBtn').href=url;
 storyBlob=null;try{c.toBlob(b=>storyBlob=b,'image/png');}catch(e){}
 storyJpg='';try{const s=document.createElement('canvas');s.width=540;s.height=960;s.getContext('2d').drawImage(c,0,0,540,960);storyJpg=s.toDataURL('image/jpeg',.85);}catch(e){}
}
let storyJpg='';
$('saveBtn').addEventListener('click',async e=>{
 const touch=matchMedia('(pointer:coarse)').matches||/iPhone|iPad|Android/i.test(navigator.userAgent);
 if(!touch)return; // masaüstünde normal indirme
 e.preventDefault();
 try{
  if(storyBlob&&navigator.canShare){const f=new File([storyBlob],'bwbh-last-call.png',{type:'image/png'});
   if(navigator.canShare({files:[f]})){await navigator.share({files:[f]});return;}}
 }catch(err){if(err&&err.name==='AbortError')return;}
 try{if(storyBlob){const u=URL.createObjectURL(storyBlob);const w=window.open(u,'_blank');if(w)return;}}catch(err){}
 toastEnd('Görsele basılı tut ve "Fotoğraflara Ekle"yi seç.');
});
$('shareBtn').onclick=async()=>{
 try{
  if(storyBlob&&navigator.canShare){const f=new File([storyBlob],'bwbh-last-call.png',{type:'image/png'});
    if(navigator.canShare({files:[f]})){track('share',{score:Math.floor(score)});await navigator.share({files:[f],text:'Last Call skorum: '+Math.floor(score).toLocaleString('tr-TR')+'. Beni geç.'});return;}}
  throw 0;
 }catch(e){toastEnd('Paylaşım burada açılmadı. Görsele basılı tutup kaydedebilirsin.');}
};
function toastEnd(m){const h=document.querySelector('.lc-story .lc-hint');h.textContent=m;}

let last=0,raf;
function loop(ts){const dt=Math.max(0,Math.min(.033,(ts-last)/1000||0));last=ts;if(running)update(dt);draw();if(running)raf=requestAnimationFrame(loop);}

function fitRoot(){const ov=[$('startOv'),$('endOv')].find(o=>!o.hidden);ROOT.style.minHeight=(ov&&!ROOT.classList.contains('is-full'))?ov.scrollHeight+'px':'';}
function start(){runN++;track('start');reset();$('startOv').hidden=true;$('endOv').hidden=true;fitRoot();running=true;over=false;last=performance.now();cancelAnimationFrame(raf);raf=requestAnimationFrame(loop);}
let diedAt=0;
function die(){running=false;over=true;diedAt=performance.now();try{navigator.vibrate&&navigator.vibrate(80)}catch(e){};beep(160,.3,'sawtooth',.06);puff(P.x+30,P.y+40,16,C.bone);draw();
 const sc=Math.floor(score);if(sc>best){best=sc;try{localStorage.setItem('bwbh_lastcall_best',best)}catch(e){};$('best').textContent=best.toLocaleString('tr-TR');}
 const tier=TIERS[tierIdx];
 $('codeBox').hidden=true;$('useBtn').hidden=true;$('useBtn').textContent='Kodu uygula, alışverişe geç';$('useBtn').classList.remove('lc-done');delete $('useBtn').dataset.busy;{const b=$('claim').querySelector('button');b.disabled=false;b.textContent='Kodu aç';}$('claim').hidden=!tier;$('email').value='';
 document.querySelector('.lc-story .lc-hint').textContent='Telefonda görsele basılı tut, fotoğraflarına kaydet.';
 $('endEyebrow').textContent='Skor '+sc.toLocaleString('tr-TR')+' · '+fmtT(t);
 if(!tier){$('endTitle').textContent='Daha ısınmadın bile.';$('prizeName').textContent='Ödül yok';$('nextLine').textContent='İlk ödül %5, '+TIERS[0].s.toLocaleString('tr-TR')+' skorda. Yaklaşık 15 saniye.';}
 else{$('endTitle').textContent=tierIdx===TIERS.length-1?'Kulübe girdin.':'Last call kaçtı. Ama boş dönmüyorsun.';
   $('prizeName').textContent=tier.name;
   const nx=TIERS[tierIdx+1];$('nextLine').textContent=nx?'Sıradaki: '+nx.name+' · '+(nx.s-sc).toLocaleString('tr-TR')+' skor uzakta':'En üst ödül. Daha yukarısı yok.';}
 makeStory(sc,tier);
 track('end',{score:sc,dur:Math.round(t),tier:tier?tier.short:'',coins});
 $('endOv').hidden=false;fitRoot();setTimeout(fitRoot,60);
}

let claimedCode='';
$('claim').addEventListener('submit',async e=>{e.preventDefault();const v=$('email').value.trim();
 if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){$('email').setCustomValidity('Geçerli bir mail adresi yaz');$('email').reportValidity();return;}
 $('email').setCustomValidity('');
 const btn=$('claim').querySelector('button');const old=btn.textContent;btn.disabled=true;btn.textContent='Hazırlanıyor…';
 const fail=m=>{btn.disabled=false;btn.textContent='Tekrar dene';$('nextLine').textContent=m;$('nextLine').style.color='var(--bone)';};
 if(!RELAY_URL)return fail('Kod şu an alınamıyor. Biraz sonra tekrar dene.');
 try{
  const body=JSON.stringify({ev:'claim',pid:PID,sid:SID,run:runN,ts:new Date().toISOString(),dev:/Mobi|Android|iPhone/i.test(navigator.userAgent)?'mobile':'desktop',ref:document.referrer||'',q:location.search||'',email:v,tier:TIERS[tierIdx].short,score:Math.floor(score),dur:Math.round(t),coins,story:storyJpg});
  const ac=new AbortController();const to=setTimeout(()=>ac.abort(),15000);const r=await fetch(RELAY_URL,{method:'POST',body,signal:ac.signal});clearTimeout(to);const raw=await r.text();let j;try{j=JSON.parse(raw);}catch(_){return fail('Sunucu eski sürümde. Biraz sonra tekrar dene.');}
  if(!j.ok||!j.code)return fail(j.error==='mail'?'Mail adresini kontrol et.':'Kod alınamadı, tekrar dene.');
  claimedCode=j.code;$('codeTxt').textContent=j.code;$('codeBox').hidden=false;$('claim').hidden=true;
  $('useBtn').href='/discount/'+j.code+'?redirect='+encodeURIComponent(SHOP_PATH);$('useBtn').hidden=false;
  $('nextLine').textContent='Kod mailine de gönderildi.';fitRoot();
 }catch(err){fail('Bağlantı sorunu. Tekrar dene.');}
});
const GIFT={'çorap':43496718237917,'tişört':68182411575517};
$('useBtn').addEventListener('click',async e=>{e.preventDefault();const href=$('useBtn').href;const c=claimedCode;const b=$('useBtn');
 if(b.dataset.busy)return;b.dataset.busy='1';
 try{await navigator.clipboard.writeText(c);}catch(err){}
 const tk=TIERS[tierIdx]&&TIERS[tierIdx].short;let msg='Kod kopyalandı: '+c+' ✓';
 if(GIFT[tk]){try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:GIFT[tk],quantity:1}]})});
   msg=r.ok?(tk==='çorap'?'Çorap sepetine eklendi ✓':'Sürpriz tişört sepetine eklendi ✓'):(tk==='çorap'?'Çoraplar tükendi, kod yine geçerli.':msg);}catch(err){}}
 b.textContent=msg;b.classList.add('lc-done');
 if(GIFT[tk])$('nextLine').textContent='Bir ürün ekle, hediye sepette 0 TL olur. Kod uygulandı.';
 setTimeout(()=>{location.href=href;},GIFT[tk]?2600:1800);
});

$('email').addEventListener('input',()=>$('email').setCustomValidity(''));
$('copyBtn').onclick=()=>{const c=$('codeTxt').textContent;navigator.clipboard.writeText(c).then(()=>{$('copyBtn').textContent='Kopyalandı'}).catch(()=>{const r=document.createRange();r.selectNodeContents($('codeTxt'));const s=getSelection();s.removeAllRanges();s.addRange(r);});};
$('startBtn').onclick=start;$('againBtn').onclick=()=>{if(performance.now()-diedAt<900)return;start();};

ROOT.addEventListener('touchstart',e=>{if(e.target.closest('button,a,input,#storyImg'))return;if(running||e.target.closest('#stage'))e.preventDefault();},{passive:false});
ROOT.addEventListener('contextmenu',e=>{if(!e.target.closest('#storyImg'))e.preventDefault();});
ROOT.addEventListener('selectstart',e=>{if(!e.target.closest('input'))e.preventDefault();});
ROOT.addEventListener('pointerdown',e=>{if(!running||e.target.closest('button,a,input'))return;e.preventDefault();press();},{passive:false});
window.addEventListener('pointerup',release);window.addEventListener('pointercancel',release);
window.addEventListener('keydown',e=>{if(!['Space','ArrowUp','KeyW'].includes(e.code))return;if(e.target.tagName==='INPUT'||e.target.tagName==='TEXTAREA')return;{const r=ROOT.getBoundingClientRect();if(r.bottom<0||r.top>window.innerHeight)return;}e.preventDefault();if(e.repeat)return;
  if(!running&&!$('startOv').hidden)return start();if(!running&&!$('endOv').hidden){if(performance.now()-diedAt>900)start();return;}if(running)press();});
window.addEventListener('keyup',e=>{if(['Space','ArrowUp','KeyW'].includes(e.code))release();});
document.addEventListener('visibilitychange',()=>{if(document.hidden&&running){running=false;cancelAnimationFrame(raf);paused=true;}else if(!document.hidden&&paused){paused=false;running=true;last=performance.now();raf=requestAnimationFrame(loop);}});
window.addEventListener('resize',resize);
const fsBtn=$('fsBtn');let usedApi=false;
function setFull(on){ROOT.classList.toggle('is-full',on);document.documentElement.classList.toggle('lc-lock',on);fsBtn.textContent=on?'×':'⤢';fsBtn.setAttribute('aria-label',on?'Tam ekrandan çık':'Tam ekran');setTimeout(resize,60);}
fsBtn.onclick=()=>{const on=!ROOT.classList.contains('is-full');
 if(on){setFull(true);try{const r=ROOT.requestFullscreen||ROOT.webkitRequestFullscreen;if(r){const p=r.call(ROOT);usedApi=true;p&&p.catch&&p.catch(()=>{usedApi=false;});}}catch(e){usedApi=false;}}
 else{try{if(document.fullscreenElement)document.exitFullscreen();else if(document.webkitFullscreenElement)document.webkitExitFullscreen();}catch(e){}setFull(false);}};
const onFs=()=>{if(usedApi&&!(document.fullscreenElement||document.webkitFullscreenElement)){usedApi=false;setFull(false);}};
document.addEventListener('fullscreenchange',onFs);document.addEventListener('webkitfullscreenchange',onFs);
window.addEventListener('keydown',e=>{if(e.key==='Escape'&&ROOT.classList.contains('is-full')&&!usedApi)setFull(false);});
resize();reset();draw();icons();
(document.fonts&&document.fonts.ready||Promise.resolve()).then(()=>{buildAll();icons();draw();});
})();